import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";
import LocationDropdown from "components/LocationDropdown/LocationDropdown";
import CustomerBreadCrumb from "pages/customers/CustomerBreadCrumb";
import { FilterGeneratedReportsData } from "./FilterGeneratedReportsData";

export default function GeneratedReportsTab(props) {

  const handleLocationChange = (location) => {
    props.onInputChange(location);
  };
const onFilterChange = (val) => {
  props.onFilterChange && props.onFilterChange({ status: val });
};

  const onRestFilter = () => {
    if (props.onFilterChange) {
      props.onFilterChange({ status: [] });
    }
  };

  function getCategoryName(category) {
    switch (category) {
      case "TRIP_BOOKING":
        return "Trip Booking";
      case "TRIP_DETAILS_REPORT": 
        return "Trip Details Report";
      case "COUPON_REPORT":
        return "Coupon Report";
      default:
        return category;
    }
  };

  function getStatus(status) {
    switch (status) {
      case "IN_PROGRESS":
        return "In Progress"; 
      case "SUCCESS":
        return "Completed";
      case "PENDING":
        return "Pending";
      case "FAILED":
        return "Failed";
      default:
        return status;
    }
  };

  const tripTypeMap = {
    '1': 'Ride',
    '3': 'Rental',
    '4': 'Airport',
    '9': 'OutStation',
  };

  const preprocessTableData = (data) => {
    if (!data || !data.body) return data;
    
    const processedData = {
      ...data,
      header: [
        ...data.header.slice(0, 2),
        { label: "Ride Type", key: "rideType" },
        ...data.header.slice(2)
      ],
      body: data.body.map(item => ({
        ...item,
        // Transform category TRIP_BOOKING to Trip Booking
        category: getCategoryName(item.category),
        // Add showLoader flag for INPROGRESS/PENDING status
        showLoader: item.status?.toLowerCase() === 'in_progress' || item.status?.toLowerCase() === 'pending',
        reportStatus: true,
        status: getStatus(item.status),
        rideType: item?.metadata?.filters?.tripType
        ? tripTypeMap[item.metadata.filters.tripType] || item.metadata.filters.tripType
        : item?.metadata?.filters?.type || 'All'
      }))
    };
    
    return processedData;
  };

  const processedTableData = preprocessTableData(props?.rideTrackData);

  return (
    <Grid container>
      <CommonBreadCrumb
        paths={[{ name: props?.title, url: "", className: "colorBlue" }]}
      />
      <Grid item className="tableContainer marginTop15" xs={12}>
        <Box className="contentBoxStyle">
          {props?.loader ? (
            <Loader />
          ) : (
            <>
              <Grid
                container
                spacing={2}
                sx={{ mb: 2 }}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12} sm={5} md={3}>
                  <LocationDropdown
                    onChange={handleLocationChange}
                  />
                </Grid>
                <Grid item>
                  {/* <CustomerBreadCrumb
                    defaultStatus={props.defaultStatus}
                    filterdata={FilterGeneratedReportsData}
                    onFilterChange={onFilterChange}
                    onRestFilter={onRestFilter}
                  /> */}
                </Grid>
              </Grid>
              <CommonTable
                data={processedTableData}
                page={props?.page}
                rowsPerPage={props?.rowsPerPage}
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                loader={props?.loader}
              />
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
